discardWatches